import { clsx } from 'clsx'
import * as React from 'react'

import { AltTagIcon, CheckIcon } from '@buffer-mono/popcorn'

import { AssetThumbnail } from '~publish/components/AssetThumbnail'
import type { AssetThumbnailActionProps } from '~publish/components/AssetThumbnail'

import styles from '../../css/MediaAttachmentThumbnail.module.css'

import type { JSX } from 'react'

const truncateText = (text: string, maxLength = 60): string =>
  text.length > maxLength ? `${text.slice(0, maxLength)}...` : text

type AltToolButtonProps = Omit<
  AssetThumbnailActionProps,
  'label' | 'tooltip' | 'children'
> & {
  altText?: string | null
}

export const AltToolButton = React.forwardRef<
  HTMLButtonElement,
  AltToolButtonProps
>(function AltToolButton(
  { className, altText, ...props },
  forwardedRef,
): JSX.Element {
  const hasAltText = Boolean(altText)
  const label = hasAltText
    ? `Edit Alt Text (Current: ${truncateText(altText ?? '', 40)})`
    : 'Add description'

  return (
    <AssetThumbnail.Action
      ref={forwardedRef}
      label={label}
      tooltip={label}
      size="small"
      className={clsx(hasAltText && styles.altButtonFilled, className)}
      {...props}
    >
      {hasAltText ? (
        <>
          <CheckIcon size="xsmall" className={styles.altButtonCheckmark} />
          <AltTagIcon />
        </>
      ) : (
        <AltTagIcon />
      )}
    </AssetThumbnail.Action>
  )
})

AltToolButton.displayName = 'AltToolButton'
